<template lang="pug">
.appNavigationItemComponent
  template(v-if="item.route")
    router-link.link(
      :to="item.route",
      active-class="_active"
    ) {{ item.label }}
  template(v-else)
    a.link(:href="item.href") {{ item.label }}
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="sass" scoped>
.appNavigationItemComponent
  position: relative
  cursor: pointer

  > .link
    white-space: nowrap
    &._active
      color: $cDarkBlue
    &:hover
      color: $cLightBlue
@media (max-width: $padWidth)
  .appNavigationItemComponent
    .link
      display: block
      padding: 2*$u 0
      font-size: 5.5*$u
@media (max-width: $mobileWidth)
  .appNavigationItemComponent
    .link
      padding: $u 0
      font-size: 5*$u

</style>
